import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { IUserDetails } from '../interface/user';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';

interface IFetchUser {
  relations?: string[];
}
interface IFetchUserConfig {
  enabled?: boolean;
}
export const useFetchUser = (params?: IFetchUser, config?: IFetchUserConfig) => {
  const queryString = params ? toQueryString(params as unknown as QueryParamObject) : null;
  const url = queryString ? `${API_URLS.GET_USER}?${queryString}` : API_URLS.GET_USER;
  const query = useQuery<IUserDetails, Error>({
    queryKey: ['user'],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: config?.enabled ?? false,
  });

  return query;
};
